import { useCallback, useEffect, useState } from 'react';

export type ThemePreference = 'light' | 'dark' | 'system';
const KEY = 'koyomi.theme';

function resolve(pref: ThemePreference): 'light' | 'dark' {
  if (pref !== 'system') return pref;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
}

export function applyTheme(pref: ThemePreference) {
  document.documentElement.dataset.theme = resolve(pref);
}

/** Tema em data-theme no <html>; respeita prefers-color-scheme; persistido por usuário (localStorage + perfil). */
export function useTheme(initial?: ThemePreference) {
  const [pref, setPref] = useState<ThemePreference>(() => {
    try {
      return (localStorage.getItem(KEY) as ThemePreference) || initial || 'system';
    } catch {
      return initial || 'system';
    }
  });
  useEffect(() => {
    applyTheme(pref);
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const onChange = () => pref === 'system' && applyTheme('system');
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [pref]);
  const set = useCallback((p: ThemePreference) => {
    setPref(p);
    try { localStorage.setItem(KEY, p); } catch { /* storage indisponível */ }
  }, []);
  return { theme: pref, setTheme: set, resolved: resolve(pref) };
}
